export default "/assets/images/whitenoise-mode.mp4?422b88c6df48f6921422037a18d41a0c";